import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const VerificationPage = () => {
  const { serialNumber } = useParams();
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // For local testing, fetch from localStorage
    const localApplications = JSON.parse(localStorage.getItem('applications')) || [];
    const foundApplication = localApplications.find(app => app.serialNumber === serialNumber);

    setTimeout(() => {
      if (foundApplication) {
        setApplication(foundApplication);
      } else {
        setError('Verification Failed: No certificate found with this serial number.');
      }
      setLoading(false);
    }, 500); // Simulate loading

  }, [serialNumber]);

  const getStatusInfo = (status) => {
    switch (status) {
      case 'approved':
        return {
          text: 'Verified by Gram Pradhan',
          color: 'green',
          icon: '✅'
        };
      case 'rejected':
        return {
          text: 'Rejected by Gram Pradhan',
          color: 'red',
          icon: '❌'
        };
      case 'pending':
        return {
          text: 'Pending for Verification',
          color: 'yellow',
          icon: '⏳'
        };
      default:
        return {
          text: 'Unknown Status',
          color: 'gray',
          icon: '❓'
        };
    }
  };
  
  const statusInfo = application ? getStatusInfo(application.status) : getStatusInfo('');

  return (
    <div className="container mx-auto px-4 py-8 flex justify-center items-center" style={{ minHeight: 'calc(100vh - 200px)' }}>
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-2xl text-center">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Certificate Verification</h1>
        
        {loading && <p className="text-lg text-gray-600">Verifying, please wait...</p>}

        {error && (
          <div className="p-4 bg-red-100 text-red-700 border border-red-400 rounded-lg">
            <p className="font-bold">Error</p>
            <p>{error}</p>
          </div>
        )}

        {application && (
          <div>
            <div className={`p-6 rounded-lg border-2 border-${statusInfo.color}-500 bg-${statusInfo.color}-50`}>
                <div className="text-6xl mb-4">{statusInfo.icon}</div>
                <p className={`text-xl font-bold text-${statusInfo.color}-800`}>{statusInfo.text}</p>
            </div>
            <div className="mt-6 text-left text-gray-700 space-y-2">
              <p><strong>Certificate Type:</strong> {application.formType}</p>
              <p><strong>Applicant Name:</strong> {application.name_en}</p>
              <p><strong>Serial Number:</strong> {application.serialNumber}</p>
              <p><strong>Submission Date:</strong> {new Date(application.submissionDate).toLocaleDateString()}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerificationPage;
